import { PcApiResponse } from '@/api/pc-api/types';
import { BizTargetType } from '@/constants/bizTargetType';
import { Role } from '@/constants/role';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type InvitingUserInfo = {
  id: string;
  email: string;
  bizTargetType: BizTargetType;
  role: Role;
  invitedAt: string;
  isInviting: boolean;
  inviteUrl: string;
};

export const getInvitingUserList = (id: string) => {
  return api<PcApiResponse<InvitingUserInfo[]>>('get', `/pc-api/v1/${PREFIX_PATH}/user/list/inviting`, { id });
};
